export default "__VITE_ASSET__B6nJH9s2__"